export interface NavSite {
  id: string;
  name: string;
  url: string;
  description: string;
  icon: string;
  tags: string[];
  category: string;
}

export interface NavCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
  sites: NavSite[];
}

export interface ArticleItem {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  imageUrl: string;
  tags: string[];
}

export const navCategories: NavCategory[] = [
  {
    slug: 'sousuo-yinqing',
    name: '搜索工具',
    icon: 'ri-search-line',
    description: '主流搜索引擎与学术搜索资源，助您快速获取信息',
    sites: [
      { id: 'baidu', name: '百度', url: 'https://www.baidu.com', description: '全球最大的中文搜索引擎，提供网页、图片、视频等搜索服务', icon: 'ri-global-line', tags: ['搜索引擎', '中文'], category: 'sousuo-yinqing' },
      { id: 'google', name: 'Google', url: 'https://www.google.com', description: '全球领先的搜索引擎，提供精准的多语言搜索服务', icon: 'ri-google-line', tags: ['搜索引擎', '国际'], category: 'sousuo-yinqing' },
      { id: 'bing', name: '必应 Bing', url: 'https://www.bing.com', description: '微软旗下的搜索引擎，集成AI智能搜索功能', icon: 'ri-search-eye-line', tags: ['搜索引擎', 'AI'], category: 'sousuo-yinqing' },
      { id: 'sogou', name: '搜狗搜索', url: 'https://www.sogou.com', description: '支持微信、知乎等独家内容搜索的中文搜索引擎', icon: 'ri-compass-3-line', tags: ['搜索引擎', '中文'], category: 'sousuo-yinqing' },
      { id: 'cnki', name: '中国知网 CNKI', url: 'https://www.cnki.net', description: '中国最大的学术资源库，涵盖期刊、论文、专利等', icon: 'ri-book-read-line', tags: ['学术', '论文'], category: 'sousuo-yinqing' },
      { id: 'wos', name: 'Web of Science', url: 'https://www.webofscience.com', description: '全球权威的学术文献检索平台，收录核心期刊论文', icon: 'ri-database-2-line', tags: ['学术', '国际'], category: 'sousuo-yinqing' },
    ],
  },
  {
    slug: 'zixun-meiti',
    name: '资讯媒体',
    icon: 'ri-newspaper-line',
    description: '国内外主流新闻媒体与资讯平台，掌握最新动态',
    sites: [
      { id: 'xinlang', name: '新浪新闻', url: 'https://news.sina.com.cn', description: '综合性新闻门户，提供时事、财经、体育等多领域资讯', icon: 'ri-pages-line', tags: ['新闻', '综合'], category: 'zixun-meiti' },
      { id: 'wangyi', name: '网易新闻', url: 'https://news.163.com', description: '有态度的新闻门户，以深度报道和跟帖文化著称', icon: 'ri-chat-quote-line', tags: ['新闻', '深度'], category: 'zixun-meiti' },
      { id: 'huxiu', name: '虎嗅', url: 'https://www.huxiu.com', description: '聚焦科技与商业创新的新媒体平台，提供深度分析', icon: 'ri-lightbulb-line', tags: ['科技', '商业'], category: 'zixun-meiti' },
      { id: '36kr', name: '36氪', url: 'https://36kr.com', description: '专注创业投资与科技商业报道的新媒体平台', icon: 'ri-rocket-line', tags: ['创业', '科技'], category: 'zixun-meiti' },
      { id: 'people', name: '人民网', url: 'https://www.people.com.cn', description: '人民日报旗下权威新闻网站，提供时政要闻与政策解读', icon: 'ri-government-line', tags: ['官方', '时政'], category: 'zixun-meiti' },
    ],
  },
  {
    slug: 'gongju-yingyong',
    name: '工具应用',
    icon: 'ri-tools-line',
    description: '实用在线工具集合，覆盖办公、设计、开发等领域',
    sites: [
      { id: 'processon', name: 'ProcessOn', url: 'https://www.processon.com', description: '在线流程图与思维导图制作工具，支持团队协作', icon: 'ri-mind-map', tags: ['设计', '协作'], category: 'gongju-yingyong' },
      { id: 'github', name: 'GitHub', url: 'https://github.com', description: '全球最大的代码托管平台，开源社区聚集地', icon: 'ri-github-line', tags: ['开发', '开源'], category: 'gongju-yingyong' },
      { id: 'figma', name: 'Figma', url: 'https://www.figma.com', description: '基于浏览器的UI/UX设计协作工具，实时同步', icon: 'ri-paint-brush-line', tags: ['设计', '协作'], category: 'gongju-yingyong' },
      { id: 'notion', name: 'Notion', url: 'https://www.notion.so', description: '全能型笔记与知识管理工具，整合文档、数据库、项目管理', icon: 'ri-sticky-note-line', tags: ['笔记', '协作'], category: 'gongju-yingyong' },
      { id: 'jinshuju', name: '金数据', url: 'https://jinshuju.net', description: '在线表单制作与数据收集平台，支持多种题型和逻辑', icon: 'ri-survey-line', tags: ['表单', '数据'], category: 'gongju-yingyong' },
      { id: 'wolai', name: '我来 Wolai', url: 'https://www.wolai.com', description: '国产双向链接笔记软件，支持块级引用和知识图谱', icon: 'ri-links-line', tags: ['笔记', '知识管理'], category: 'gongju-yingyong' },
    ],
  },
  {
    slug: 'xuexi-jiaoyu',
    name: '学习教育',
    icon: 'ri-graduation-cap-line',
    description: '优质在线学习平台，涵盖编程、语言、职业技能等课程',
    sites: [
      { id: 'mooc', name: '中国大学MOOC', url: 'https://www.icourse163.org', description: '汇集国内顶尖高校精品课程，免费在线学习平台', icon: 'ri-vidicon-line', tags: ['大学', '免费'], category: 'xuexi-jiaoyu' },
      { id: 'bilibili', name: '哔哩哔哩', url: 'https://www.bilibili.com', description: '年轻世代聚集的视频社区，海量学习教程资源', icon: 'ri-tv-line', tags: ['视频', '综合'], category: 'xuexi-jiaoyu' },
      { id: 'juejin', name: '掘金', url: 'https://juejin.cn', description: '面向开发者的技术社区，分享前端、后端、AI等技术文章', icon: 'ri-code-line', tags: ['技术', '社区'], category: 'xuexi-jiaoyu' },
      { id: 'coursera', name: 'Coursera', url: 'https://www.coursera.org', description: '全球知名在线教育平台，提供世界名校认证课程', icon: 'ri-global-line', tags: ['国际', '认证'], category: 'xuexi-jiaoyu' },
      { id: 'zhihu', name: '知乎', url: 'https://www.zhihu.com', description: '高质量问答社区，各领域专业人士分享知识与见解', icon: 'ri-question-answer-line', tags: ['问答', '知识'], category: 'xuexi-jiaoyu' },
    ],
  },
  {
    slug: 'yule-xiuxian',
    name: '娱乐休闲',
    icon: 'ri-emotion-happy-line',
    description: '放松身心的娱乐平台，视频、音乐、游戏一应俱全',
    sites: [
      { id: 'douyin', name: '抖音', url: 'https://www.douyin.com', description: '短视频社交平台，记录美好生活的创意社区', icon: 'ri-music-line', tags: ['短视频', '社交'], category: 'yule-xiuxian' },
      { id: 'xiaohongshu', name: '小红书', url: 'https://www.xiaohongshu.com', description: '生活方式分享平台，涵盖穿搭、美食、旅行等内容', icon: 'ri-bookmark-line', tags: ['生活方式', '种草'], category: 'yule-xiuxian' },
      { id: 'douban', name: '豆瓣', url: 'https://www.douban.com', description: '书影音评分与社区平台，发现你的精神角落', icon: 'ri-star-line', tags: ['书影音', '社区'], category: 'yule-xiuxian' },
      { id: 'netease-music', name: '网易云音乐', url: 'https://music.163.com', description: '以歌单和评论文化著称的音乐流媒体平台', icon: 'ri-headphone-line', tags: ['音乐', '社区'], category: 'yule-xiuxian' },
      { id: 'iqiyi', name: '爱奇艺', url: 'https://www.iqiyi.com', description: '中国领先的在线视频平台，提供海量影视综艺内容', icon: 'ri-film-line', tags: ['视频', '影视'], category: 'yule-xiuxian' },
    ],
  },
  {
    slug: 'gouwu-shenghuo',
    name: '购物生活',
    icon: 'ri-shopping-cart-line',
    description: '主流电商平台与生活服务网站，满足日常消费需求',
    sites: [
      { id: 'taobao', name: '淘宝', url: 'https://www.taobao.com', description: '中国最大的C2C电商平台，万能的购物天堂', icon: 'ri-store-line', tags: ['电商', '综合'], category: 'gouwu-shenghuo' },
      { id: 'jd', name: '京东', url: 'https://www.jd.com', description: '自营正品保障的B2C电商平台，物流快速可靠', icon: 'ri-truck-line', tags: ['电商', '自营'], category: 'gouwu-shenghuo' },
      { id: 'pdd', name: '拼多多', url: 'https://www.pinduoduo.com', description: '社交电商平台，拼团购物享受超值优惠', icon: 'ri-group-line', tags: ['电商', '社交'], category: 'gouwu-shenghuo' },
      { id: 'meituan', name: '美团', url: 'https://www.meituan.com', description: '本地生活服务超级App，吃喝玩乐一站式解决', icon: 'ri-restaurant-line', tags: ['生活', '本地'], category: 'gouwu-shenghuo' },
      { id: 'dianping', name: '大众点评', url: 'https://www.dianping.com', description: '本地消费指南，发现身边的美食、休闲、娱乐好去处', icon: 'ri-thumb-up-line', tags: ['本地', '评价'], category: 'gouwu-shenghuo' },
    ],
  },
  {
    slug: 'shejiao-tongxun',
    name: '社交通讯',
    icon: 'ri-chat-smile-2-line',
    description: '主流社交平台与通讯工具，连接你我沟通无界限',
    sites: [
      { id: 'weixin', name: '微信', url: 'https://weixin.qq.com', description: '中国最受欢迎的即时通讯与社交平台', icon: 'ri-wechat-line', tags: ['即时通讯', '社交'], category: 'shejiao-tongxun' },
      { id: 'weibo', name: '微博', url: 'https://weibo.com', description: '社交媒体平台，热点事件第一时间传播与讨论', icon: 'ri-chat-1-line', tags: ['社交', '热点'], category: 'shejiao-tongxun' },
      { id: 'feishu', name: '飞书', url: 'https://www.feishu.cn', description: '字节跳动旗下企业协作平台，整合即时通讯与文档协作', icon: 'ri-message-2-line', tags: ['办公', '协作'], category: 'shejiao-tongxun' },
      { id: 'dingtalk', name: '钉钉', url: 'https://www.dingtalk.com', description: '阿里巴巴旗下企业通讯与协同办公平台', icon: 'ri-building-line', tags: ['办公', '企业'], category: 'shejiao-tongxun' },
    ],
  },
  {
    slug: 'sheji-linggan',
    name: '设计灵感',
    icon: 'ri-palette-line',
    description: '设计师必备灵感资源站，发现优秀作品与设计趋势',
    sites: [
      { id: 'dribbble', name: 'Dribbble', url: 'https://dribbble.com', description: '全球顶尖设计师作品展示社区，灵感源泉', icon: 'ri-dribbble-line', tags: ['设计', '社区'], category: 'sheji-linggan' },
      { id: 'behance', name: 'Behance', url: 'https://www.behance.net', description: 'Adobe旗下创意作品展示平台，涵盖各设计领域', icon: 'ri-brush-3-line', tags: ['设计', '作品集'], category: 'sheji-linggan' },
      { id: 'zcool', name: '站酷 ZCOOL', url: 'https://www.zcool.com.cn', description: '中国最大的设计师互动平台，本土设计作品聚集地', icon: 'ri-artboard-line', tags: ['设计', '中文'], category: 'sheji-linggan' },
      { id: 'pinterest', name: 'Pinterest', url: 'https://www.pinterest.com', description: '图片灵感收集平台，通过Pin发现和收藏创意', icon: 'ri-pushpin-line', tags: ['灵感', '图片'], category: 'sheji-linggan' },
    ],
  },
];

export const articles: ArticleItem[] = [
  {
    slug: '2025-bi-bei-gong-ju',
    title: '2025年程序员必备的10个在线工具网站',
    excerpt: '本文精选了10个程序员日常开发中不可或缺的在线工具，涵盖代码编辑、API调试、正则测试、JSON格式化等领域，助你提升开发效率。',
    content: '在软件开发领域，善用工具可以大幅提升工作效率。以下是2025年程序员必备的10个在线工具网站：\n\n1. **GitHub Copilot**：AI编程助手，基于上下文自动补全代码，支持多种主流IDE。\n\n2. **JSON Crack**：将JSON数据可视化为树状图，直观理解复杂数据结构。\n\n3. **RegExr**：交互式正则表达式学习与测试工具，配有详细语法解释。\n\n4. **Postman Web**：在线API调试工具，无需下载即可测试接口。\n\n5. **Carbon**：将代码片段生成美观的截图，适合分享到社交媒体。\n\n6. **DevDocs**：多编程语言与框架离线文档聚合平台。\n\n7. **Transform Tools**：代码格式转换集合，支持JS到TS、CSS到Tailwind等。\n\n8. **Excalidraw**：手绘风格的在线白板工具，适合绘制架构图。\n\n9. **CodeSandbox**：在线代码编辑器，快速搭建和分享Web项目原型。\n\n10. **SQLite Viewer**：在线SQLite数据库查看与编辑器，轻量级数据管理。\n\n以上工具均可在浏览器中直接使用，无需安装任何软件，建议收藏备用。',
    category: 'gongju-yingyong',
    author: '蓝导航编辑部',
    date: '2025-03-15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20developer%20workspace%20with%20laptop%20showing%20code%20editor%2C%20warm%20ambient%20lighting%2C%20clean%20minimal%20desk%20setup%20with%20coffee%20cup%2C%20professional%20coding%20environment%2C%20soft%20natural%20light%20from%20window%2C%20cozy%20home%20office%20aesthetic%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=article-tools-01&orientation=landscape',
    tags: ['开发工具', '效率提升', '程序员'],
  },
  {
    slug: 'sou-suo-ji-qiao',
    title: '搜索引擎高级技巧：让你搜索效率翻倍的8个秘诀',
    excerpt: '掌握这些高级搜索语法和技巧，让你在海量信息中精准锁定目标内容，告别大海捞针式的低效搜索。',
    content: '搜索引擎是我们获取信息的主要入口，但大多数人只会输入关键词。掌握以下8个高级技巧，让你的搜索效率翻倍：\n\n1. **精确搜索**：使用双引号包裹关键词，例如 "蓝导航" 只会返回包含完整词语的结果。\n\n2. **排除关键词**：使用减号排除不相关内容，例如 网址导航 -广告。\n\n3. **站点限定**：使用 site:域名 在特定网站内搜索，例如 site:github.com 网址导航。\n\n4. **文件类型**：使用 filetype:pdf 搜索特定格式文件，适合找文档资料。\n\n5. **通配符搜索**：使用星号 * 代替不确定的词语，搜索引擎会自动匹配。\n\n6. **时间限定**：利用搜索工具按时间筛选结果，获取最新信息。\n\n7. **相关网站**：使用 related:域名 查找相似网站，拓展信息来源。\n\n8. **组合搜索**：将多个技巧组合使用，实现精准定位。\n\n熟练运用这些技巧，你将成为信息检索的高手，在工作学习中事半功倍。',
    category: 'sousuo-yinqing',
    author: '蓝导航编辑部',
    date: '2025-04-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20search%20engine%20interface%20on%20a%20clean%20desktop%20screen%2C%20warm%20golden%20light%20accent%2C%20modern%20workspace%20with%20notebook%20and%20pen%2C%20professional%20yet%20inviting%20atmosphere%2C%20editorial%20style%20with%20soft%20shadows%2C%20clean%20composition&width=800&height=450&seq=article-search-02&orientation=landscape',
    tags: ['搜索技巧', '效率提升', '搜索工具'],
  },
  {
    slug: 'she-ji-zi-yuan',
    title: '设计师收藏夹大公开：这些设计资源网站你一定用得上',
    excerpt: '从配色方案到图标素材，从字体选择到灵感收集，本文整理了设计师日常工作中最常用的资源网站合集。',
    content: '优秀的设计离不开优质资源的支撑。以下就是我们精心整理的设计师必备资源网站：\n\n1. **配色灵感**：Coolors.co 提供一键生成配色方案；中国色 收录中国传统色彩；Adobe Color 支持从图片提取配色。\n\n2. **图标素材**：Remix Icon 开源图标库，风格统一；Font Awesome 经典图标字体库；IconPark 字节跳动开源图标库。\n\n3. **字体资源**：Google Fonts 免费开源字体库；字由 中文字体管理工具；100font 免费商用字体下载。\n\n4. **灵感平台**：Dribbble 全球设计作品展示；站酷 中国设计师社区；Muzli 设计灵感浏览器插件。\n\n5. **图片素材**：Unsplash 高质量免费图片；Pexels 免费素材视频与图片；Remove.bg 一键消除图片背景。\n\n6. **效率工具**：TinyPNG 图片在线压缩；Photopea 在线版Photoshop；CleverPDF 在线PDF处理工具。\n\n以上资源可以覆盖设计师90%的日常工作需求，建议按照自己的使用习惯整理收藏夹，打造个人专属的设计工具箱。',
    category: 'sheji-linggan',
    author: '蓝导航编辑部',
    date: '2025-04-18',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20workspace%20with%20color%20palette%20swatches%20and%20sketch%20notebook%2C%20warm%20natural%20lighting%2C%20creative%20studio%20aesthetic%2C%20minimal%20clean%20desk%20with%20design%20tools%2C%20artistic%20atmosphere%20with%20plants%2C%20editorial%20photography%20with%20soft%20warm%20tones&width=800&height=450&seq=article-design-03&orientation=landscape',
    tags: ['设计资源', '设计师', '灵感收集'],
  },
  {
    slug: 'xue-xi-ping-tai-tui-jian',
    title: '免费自学编程的最佳平台推荐：从入门到进阶',
    excerpt: '编程学习不一定要花钱报班，本文精选了国内外优质的免费编程学习平台，覆盖前端、后端、算法等方向。',
    content: '互联网时代，自学编程比以往任何时候都更加便捷。以下是精选的免费编程学习平台：\n\n1. **FreeCodeCamp**：全球最大的免费编程学习社区，提供完整的Web开发课程体系，完成后可获得认证。\n\n2. **中国大学MOOC**：国内顶尖高校的计算机课程，从C语言到人工智能，体系完整。\n\n3. **The Odin Project**：开源的全栈Web开发课程，注重实战项目驱动。\n\n4. **CS50 (哈佛大学)**：世界上最受欢迎的计算机科学入门课程，中文字幕齐全。\n\n5. **LeetCode**：算法刷题平台，面试必备，支持多种编程语言。\n\n6. **MDN Web Docs**：Mozilla官方Web技术文档，最权威的前端学习资料。\n\n7. **哔哩哔哩**：海量免费编程教程视频，从入门到项目实战全面覆盖。\n\n8. **GitHub**：开源项目是最好的学习素材，阅读优秀代码是进阶的捷径。\n\n坚持每天学习1-2小时，配合实际项目练习，半年内即可具备独立开发能力。',
    category: 'xuexi-jiaoyu',
    author: '蓝导航编辑部',
    date: '2025-05-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20online%20learning%20setup%20with%20laptop%20displaying%20programming%20tutorial%2C%20warm%20cozy%20study%20environment%2C%20notebooks%20and%20coffee%20on%20wooden%20desk%2C%20natural%20light%2C%20educational%20atmosphere%2C%20soft%20warm%20color%20palette&width=800&height=450&seq=article-learn-04&orientation=landscape',
    tags: ['编程学习', '自学', '免费资源'],
  },
  {
    slug: 'xin-wen-zi-xun-lai-yuan',
    title: '资讯获取指南：如何高效阅读新闻并保持信息敏感度',
    excerpt: '信息过载时代，学会筛选高质量资讯来源比阅读数量更重要，本文分享高效获取资讯的方法论。',
    content: '在信息爆炸的时代，如何高效地获取有价值的资讯是一门必修课：\n\n1. **RSS订阅**：使用Feedly或Inoreader订阅你关注的博客和媒体，将信息聚合到一处。\n\n2. **Newsletter**：订阅行业专家的邮件通讯，如阮一峰的网络日志，获取深度内容。\n\n3. **社交媒体筛选**：在微博和Twitter上建立高质量的关注列表，利用列表功能分类浏览。\n\n4. **播客**：通勤时间听行业播客，如「硅谷早知道」、「乱翻书」等，获取深度讨论。\n\n5. **垂直社区**：针对特定领域，关注知乎专栏、少数派、Product Hunt等垂直平台。\n\n6. **AI摘要工具**：利用AI工具对长文进行摘要提炼，快速判断是否值得精读。\n\n7. **定期整理**：每周花30分钟整理收藏夹，清理过时内容，保持信息库的鲜活性。\n\n高质量的信息输入决定你的认知水平，建立自己的信息获取体系比盲目阅读更加重要。',
    category: 'zixun-meiti',
    author: '蓝导航编辑部',
    date: '2025-06-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20reading%20nook%20with%20tablet%20displaying%20news%20articles%2C%20warm%20morning%20light%2C%20cozy%20armchair%20with%20throw%20blanket%2C%20minimalist%20interior%20design%2C%20peaceful%20atmosphere%2C%20editorial%20photography%20with%20soft%20natural%20tones&width=800&height=450&seq=article-news-05&orientation=landscape',
    tags: ['资讯获取', '信息管理', '效率'],
  },
  {
    slug: 'yuan-cheng-ban-gong',
    title: '远程办公效率工具大全：在家办公也能高效产出的秘诀',
    excerpt: '远程办公已成为新常态，本文整理了一整套远程协作工具链，帮你打造高效的远程工作流。',
    content: '远程办公的核心挑战在于沟通效率和自我管理。以下是经过实战验证的远程办公工具链：\n\n1. **即时通讯**：飞书、钉钉、Slack，选择适合团队规模的工具。\n\n2. **视频会议**：腾讯会议稳定性好；Zoom功能全面；Google Meet无需安装。\n\n3. **文档协作**：Notion适合知识库管理；Google Docs实时协作体验优秀；语雀适合中文团队。\n\n4. **项目管理**：Trello看板式简单直观；Jira适合大型研发团队；飞书多维表格新型管理方式。\n\n5. **设计协作**：Figma多人实时设计协作，已成为行业标准。\n\n6. **时间管理**：Toggl Track时间追踪；番茄ToDo专注计时；RescueTime自动统计。\n\n7. **云存储**：百度网盘、阿里云盘国内首选；Google Drive国际协作方便。\n\n8. **密码管理**：1Password或Bitwarden，统一管理团队共享账号。\n\n关键是找到适合自己团队的工具组合，而非追求功能最全的工具。',
    category: 'gongju-yingyong',
    author: '蓝导航编辑部',
    date: '2025-06-20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20home%20office%20setup%20with%20dual%20monitors%20and%20ergonomic%20chair%2C%20warm%20natural%20lighting%20through%20large%20window%2C%20minimalist%20desk%20with%20plants%20and%20notebook%2C%20professional%20yet%20comfortable%20workspace%2C%20modern%20interior%20design&width=800&height=450&seq=article-remote-06&orientation=landscape',
    tags: ['远程办公', '效率工具', '协作'],
  },
];

export const aboutData = {
  brand: {
    name: '蓝导航',
    slogan: '精选网址导航，一站直达精彩',
    introduction: '蓝导航成立于2023年，是国内领先的网址导航服务平台。我们致力于为用户提供最优质、最全面的网站资源聚合服务，让每一位用户都能快速找到所需网站，节省上网时间，提升浏览效率。',
    mission: '连接用户与优质互联网资源，打造最值得信赖的网址导航平台。',
    vision: '成为中文互联网用户首选的网址导航入口，让信息获取更简单、更高效。',
    values: ['用户至上：始终以用户需求为核心，持续优化导航体验', '品质精选：严格审核每一个收录网站，确保内容质量', '持续创新：紧跟互联网发展趋势，不断引入新技术新功能', '开放共享：保持开放心态，与用户和合作伙伴共同成长'],
  },
  reputation: [
    { name: '张先生', role: '互联网从业者', content: '蓝导航是我每天必用的网站，分类清晰，网站质量高，帮我省去了大量搜索时间。尤其喜欢它的分类筛选功能，找工具类网站特别方便。', rating: 5, date: '2025-07-15' },
    { name: '李女士', role: '设计师', content: '作为设计师，蓝导航的设计灵感分类对我帮助很大。收集了很多优秀的设计资源网站，而且更新及时，总能发现新的好网站。', rating: 5, date: '2025-07-10' },
    { name: '王同学', role: '大学生', content: '蓝导航收录的学习网站非常全面，从学术搜索到在线课程应有尽有。写论文找资料的时候特别方便，强烈推荐给学生朋友。', rating: 5, date: '2025-07-05' },
    { name: '陈先生', role: '自由职业者', content: '远程办公后更依赖在线工具，蓝导航的工具应用分类帮我发现了很多提高效率的好网站。界面简洁，使用体验非常好。', rating: 4, date: '2025-06-28' },
    { name: '刘女士', role: '自媒体运营', content: '每天都在用蓝导航找资讯来源和素材网站，分类很实用，更新频率也高。已经推荐给很多同行朋友了。', rating: 5, date: '2025-06-20' },
    { name: '赵先生', role: '创业者', content: '蓝导航收录的创业相关网站很实用，从行业资讯到工具平台一应俱全。对于刚起步的创业者来说，是一个很好的资源入口。', rating: 5, date: '2025-06-15' },
  ],
  contact: {
    email: 'contact@lan-dao.com',
    wechat: '蓝导航官方',
    address: '北京市海淀区中关村科技园区',
    phone: '400-888-0000',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};

export const faqData = [
  { question: '蓝导航收录网站的标准是什么？', answer: '我们遵循严格的审核标准，收录的网站需满足以下条件：内容合法合规、信息真实准确、网站稳定可靠、用户体验良好。我们的编辑团队会对每个提交的网站进行人工审核，确保收录网站的质量。' },
  { question: '如何向蓝导航提交网站？', answer: '您可以通过关于我们页面的联系表单提交网站信息，或直接发送邮件至contact@lan-dao.com。提交时请提供网站名称、网址、简短描述和所属分类，我们的编辑团队将在3-5个工作日内完成审核。' },
  { question: '蓝导航的分类会定期更新吗？', answer: '是的，我们会根据互联网发展趋势和用户需求，定期对分类体系进行优化调整。同时，每个分类下的网站列表也会持续更新，及时添加优质新网站，移除失效或质量下降的网站。' },
  { question: '蓝导航是否收费？', answer: '蓝导航对普通用户完全免费。我们致力于为所有用户提供优质的网址导航服务，无需注册即可使用全部功能。' },
  { question: '使用蓝导航需要注册账号吗？', answer: '不需要。蓝导航是一个完全开放的网址导航平台，所有功能均可直接使用，无需注册或登录。' },
];